import { QueryProvider } from './QueryProvider'
import { AntdConfigProvider } from './AntdConfigProvider'
import type { ReactNode } from 'react'
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary'

/** Single composition point for all app-wide providers. */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <AntdConfigProvider>{children}</AntdConfigProvider>
      </QueryProvider>
    </ErrorBoundary>
  )
}
